export enum SourceType {
  EventType = 1,
  InternalCalendar = 2,
  IntegrationCalendar = 3,
  EventTypeInquiry = 4,
  FormAnswer = 5,
  FormInquiry = 6,
}

export const isInquirySourceType = (sourceType: SourceType | null) => {
  if (!sourceType) return false;
  return [SourceType.EventTypeInquiry, SourceType.FormInquiry].includes(
    sourceType,
  );
};

export const hasContactSourceType = (sourceType: SourceType | null) => {
  if (!sourceType) return false;
  return [
    SourceType.EventType,
    SourceType.EventTypeInquiry,
    SourceType.FormInquiry,
  ].includes(sourceType);
};
